import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { type Slide } from '@/types/swiper';
import slider from '@/js/components/common/ui/slider.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSlider',
  props: {
    slidesJson: {},
    imageWidth: {},
    imageHeight: {}
  },
  setup(__props: any) {

const props = __props;
const slides: Slide[] = JSON.parse(props.slidesJson);

return (_ctx: any,_cache: any) => {
  return (_unref(slides).length > 0)
    ? (_openBlock(), _createBlock(slider, {
        key: 0,
        slides: _unref(slides),
        "image-width": _ctx.imageWidth,
        "image-height": _ctx.imageHeight,
        effect: "fade",
        navigation: false
      }, null, 8, ["slides", "image-width", "image-height"]))
    : _createCommentVNode("", true)
}
}

})